import "./socialmedia.scss";

interface ISocialMedia {
    theme:string;
}

const SocialMedia = ({theme}:ISocialMedia) => {
    return (
        <div className="d-flex align-items-center justify-content-center mb-3">
            <div className={"Social-Media d-flex justify-content-center align-items-center Social-Media-" + theme }>
                <img src={theme === "Light" ? require('../../assets/images/icons/TelegramLight.svg').default : require("../../assets/images/icons/TelegramDark.svg").default} alt=""
                     className="img-fluid"/>
            </div>
            <div className={"Social-Media d-flex justify-content-center align-items-center Social-Media-" + theme }>
                <img src={theme === "Light" ? require("../../assets/images/icons/WhatsappLight.svg").default : require("../../assets/images/icons/WhatsappDark.svg").default} alt=""
                     className="img-fluid"/>
            </div>
            <div className={"Social-Media d-flex justify-content-center align-items-center Social-Media-" + theme }>
                <img src={theme === "Light" ? require("../../assets/images/icons/InstagramLight.svg").default : require("../../assets/images/icons/InstagramDark.svg").default} alt=""
                     className="img-fluid"/>
            </div>
        </div>
    );
}

export default SocialMedia;